import { render, staticRenderFns } from "./invitePlan.vue?vue&type=template&id=60805ee0&scoped=true&"
import script from "./invitePlan.vue?vue&type=script&lang=js&"
export * from "./invitePlan.vue?vue&type=script&lang=js&"
import style0 from "./invitePlan.vue?vue&type=style&index=0&id=60805ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60805ee0",
  null
  
)

export default component.exports